import styled from "styled-components";

export const Title = styled.h3`
  font-family: "Dosis", sans-serif;
`
